<template>
  <div ref="root" class="news topPage">
    <div class="slider-outer">
      <div class="slider-inner">
        <template :key="idx" v-for="(slide, idx) in state.slides">
          <img :class="state.current_slide == idx ? 'active' : ''" class="slide-img" v-bind:src="state.slides[idx].img" />
        </template>
      </div>
      <div class="over-ray">
        <div class="top-inner">
          <div class="top-items-title">
            <h2>News</h2>
            <p>お知らせ</p>
          </div>
        </div>
      </div>
    </div>
    <div class="news-content">
      <div class="news-content-date">
        {{ products[$route.query.id].date }}
      </div>
      <div class="news-content-title">
        {{ products[$route.query.id].title }}
      </div>
      <div class="news-content-text" v-html="products[$route.query.id].text"></div>

      <div class="price-button">
        <div class="button-wrap">
          <div class="button">
            <router-link to="/#news" @click="onTapReturnButton">
              <div class="icon-arrow-left"></div>
              戻る
            </router-link>
          </div>
        </div>
      </div>

      <div class="news-bg">
        <img src="~@/assets/img/logo/logo_simple.png" />
      </div>
      <div class="news-bg2">
        Make The Body<br />
        You Dream About
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, reactive, onMounted, onUpdated, computed } from 'vue'
import IScroll from 'iscroll'
import dayjs from 'dayjs'
import { useApplicationStore } from '@/store/modules/applicationModule'

interface State {
  iScrollObj: null | IScroll
  slides: any
  current_slide: any
  visible: any
}

export default defineComponent({
  components: {},
  props: {
    products: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const ApplicationStore = useApplicationStore()
    const root = ref(null)
    const state = reactive<State>({
      iScrollObj: null,
      slides: [{ img: require('@/assets/img/news/2.jpg') }, { img: require('@/assets/img/news/1.jpg') }, { img: require('@/assets/img/news/3.jpg') }],
      current_slide: null,
      visible: true,
    })

    const shouldShowTopPanel = computed(() => ApplicationStore.getShouldShowTopPanel)

    const myFunc5 = function () {
      const target = document.getElementsByClassName('fade-right')
      const position = Math.floor(window.innerHeight * 0.75)

      for (let i = 0; i < target.length; i++) {
        let offsetTop = Math.floor(target[i].getBoundingClientRect().top)
        let offsetBottom = Math.floor(target[i].getBoundingClientRect().bottom)

        if (offsetTop < position) {
          target[i].classList.add('active')
        } else {
          target[i].classList.remove('active')
        }

        if (offsetBottom < 0) {
          target[i].classList.remove('active')
        }
      }
    }

    const myFunc = function () {
      const target = document.getElementsByClassName('fade-left')
      const position = Math.floor(window.innerHeight * 0.75)

      for (let i = 0; i < target.length; i++) {
        let offsetTop = Math.floor(target[i].getBoundingClientRect().top)
        let offsetBottom = Math.floor(target[i].getBoundingClientRect().bottom)

        if (offsetTop < position) {
          target[i].classList.add('active')
        } else {
          target[i].classList.remove('active')
        }

        if (offsetBottom < 0) {
          target[i].classList.remove('active')
        }
      }
    }

    window.addEventListener('scroll', async function () {
      myFunc(), false
      myFunc5(), false
    })

    const onTapReturnButton = () => {
      state.visible = false
    }

    setTimeout(() => {
      if (state.current_slide === null) {
        state.current_slide = 2
      }
    }, 300)

    // 実行したい処理
    setInterval(() => {
      state.current_slide = state.current_slide < state.slides.length - 1 ? state.current_slide + 1 : 0
      // console.log(state.current_slide)
    }, 8000)

    return {
      root,
      state,
      onTapReturnButton,
    }
  },
})
</script>

<style lang="scss" scoped>
@import '~@/assets/css/colors';

img {
  width: 100%;
}

.news {
  font-family: 'Shippori Mincho', serif;
  display: flex;
  flex-wrap: wrap;

  &-bg {
    opacity: 0.1;
    position: fixed;
    right: 0;
    bottom: 0;
    z-index: -1;
  }

  &-bg2 {
    font-family: 'mafw';
    font-size: 6rem;
    opacity: 0.1;
    position: fixed;
    left: 40px;
    top: 100px;
    z-index: -1;
  }
  & .top-items-title {
    text-align: left;
    /* width: 20%; */
    padding-left: 2%;

    h2 {
      font-size: 2rem;
    }
    p {
      font-size: 4.8rem;
    }
  }

  &-content {
    position: relative;
    max-width: 1200px;
    width: 90%;
    margin: 0 auto;

    &-date {
      font-size: 1.4rem;
      letter-spacing: 1.5;
    }

    &-title {
      font-size: 2.4rem;
      border-bottom: 1px solid #c2c3cc;
      padding-bottom: 10px;
    }

    &-text {
      margin-top: 40px;
      border-bottom: 1px solid #c2c3cc;
      padding-bottom: 120px;
      font-size: 1.4rem;
    }
  }
}

.slider-outer {
  position: relative;
  width: 100vw;
  height: 100vh;
  margin: 0 auto 20px;
}

.slider-inner {
  position: relative;
  width: 100%;
  height: 90%;
  overflow: hidden;
}

.slide-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  top: 0;
  opacity: 0;
  transform: scale(1.1);

  &.active {
    transition: transform 8000ms ease-out 0s, opacity 800ms ease 0s;
    opacity: 1;
    transform: scale(1.2);
  }
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 800ms ease 0s;
  opacity: 1;
}

.fade-enter-active {
  transition: transform 8000ms ease-out 0s;
  transform: scale(1.2);
}

.fade-enter-to {
  transform: scale(1.1);
}

.over-ray {
  width: 100%;
  height: 90%;
  background-color: rgba($color: #000000, $alpha: 0.5);
  position: absolute;
  top: 0;
}

.title-wrap {
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  text-align: center;
  flex-direction: column;
  margin-bottom: 120px;
  font-weight: 900;

  & h1 {
    font-size: 4rem;
    font-weight: 900;
    line-height: 1;
  }

  & h2 {
    font-size: 3rem;
    font-weight: 900;
  }
}

#title {
  text-align: center;
}

.top-inner {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  color: #fff;
  font-size: 8rem;
  font-family: 'Shippori Mincho', serif;
  font-weight: 500;
  letter-spacing: 0.5px;
  text-align: center;

  &-img {
    max-width: 600px;
    width: 100%;
  }
}

.l_noiseMotion,
.l_videoBox .l_video {
  // height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}

.l_videoBox .l_video {
  object-fit: cover;
  position: relative;
}

.TopPageVideo {
  left: 28.6%;
  position: fixed;
  top: 5vw;
  width: 67%;
  z-index: 1;
  -webkit-transition: all 1s;
  -moz-transition: all 1s;
  -ms-transition: all 1s;
  -o-transition: all 1s;
  transition: all 1s;

  &.active {
    position: fixed;
    width: 100%;
    left: 0;
    top: 0;
    -webkit-transition: all 1s;
    -moz-transition: all 1s;
    -ms-transition: all 1s;
    -o-transition: all 1s;
    transition: all 1s;

    &.l_videoBox .l_videoBoxInner {
      height: 0;
      overflow: hidden;
      padding-bottom: 100%;
      position: relative;
      width: 100%;
    }

    &.l_videoBox .l_video {
      height: 100%;
      left: 0;
      position: absolute;
      top: 0;
      width: auto;
    }
  }
}

.l_videoBox {
  overflow: hidden;
}

.l_videoBox .l_videoBoxInner {
  height: 0;
  overflow: hidden;
  padding-bottom: 53%;
  position: relative;
  width: 100%;
}

.l_noiseMotion {
  animation: noise 0.2s steps(1) infinite;
  backface-visibility: hidden;
  background: #010719 url('~@/assets/img/video/noise_bg.png') repeat 0 0;
  background-repeat: repeat;
  background-size: 200px 200px;
  bottom: 0;
  opacity: 0.5;
  overflow: hidden;
  pointer-events: none;
  right: 0;
  transform-origin: 50% 50%;
  will-change: transform;
  z-index: 2;
}

.TopPage .l_primaryContent {
  position: relative;
  z-index: 3;
}

.TopPageHead {
  position: relative;
  padding-bottom: 140px;
  // pointer-events: none;
  z-index: 2;
  padding-top: 100px;
}

.l_primaryBox {
  padding-left: 4.4%;
  padding-right: 4.4%;
}

.TopPageHead .TopPageHeadTitle {
  position: relative;
  width: 60%;
  z-index: 2;
}

.TopPageHead .TopPageHeadTitle .TopPageHeadTitleRead {
  bottom: 0;
  color: #fff;
  font-size: 24px;
  font-weight: 700;
  letter-spacing: 0.02em;
  position: absolute;
  right: -12vw;
}

.head-title {
  color: #fff;
  font-size: 8rem;
  font-family: 'Shippori Mincho', serif;
}

.head-subtitle-wrap {
  margin-top: 120px;
  width: 100%;
  position: relative;

  & .price-item-des-wrap-one .price-item-des {
    margin-top: 0;
  }

  & .price-item-des-wrap {
    color: #fff;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;

    & .price-item-des-title {
      font-size: 30px;
    }

    & .arrow-bottom {
      display: inline-block;
      width: 18px;
      height: 18px;
      margin: 0 40px;
      border-bottom: 4px solid #fff;
      border-right: 4px solid #fff;
      transform: translateX(-100%) rotate(-45deg);
      opacity: 0;
      -webkit-transition: all 1s;
      -moz-transition: all 1s;
      -ms-transition: all 1s;
      -o-transition: all 1s;
      transition: all 1s;

      &.active {
        transform: translateX(0) rotate(-45deg);
        opacity: 1;
      }
    }
  }
}

.head-subtitle-bottomwrap {
  display: flex;
  flex-direction: column;
  align-items: center;

  .head-subtitle {
    text-align: center;
    color: #fff;
    font-size: 6rem;
  }
}

.head-subtitle {
  color: #fff;
  background-color: $sub;
  display: inline-block;
  padding: 5px;
  font-size: 4rem;
  font-weight: 900;
}

.js-inViewAct {
  animation: inViewActKey 1s;
  animation-delay: 0s;
  animation-fill-mode: forwards;
  animation-timing-function: cubic-bezier(0.4, 0.005, 0.14, 1);
  backface-visibility: hidden;
  transform-origin: left top;
  will-change: transform;
}

.WhiteBack {
  background-color: #fff;
  position: relative;
  z-index: 3;
}

.BlackBack {
  // background-color: $main;
  color: #fff;
  position: relative;
  z-index: 3;
}

.price-item {
  display: flex;
  font-size: 20px;
  font-weight: 900;
  margin-bottom: 40px;
  flex-direction: column;
  width: 33%;

  &-wrap {
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
  }

  &-middle {
    &-wrap {
      display: flex;
      align-items: center;
      flex-direction: column;
    }
  }
}

.price-item-title {
  width: 100%;
  height: 70px;
  margin: 15px 0;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-right: 70px;
  background: $main;
  position: relative;
  color: #fff;
}

.price-item-des {
  &-numtext {
    font-size: 50px;
    margin-right: -3px;
    position: relative;

    &::after {
      position: absolute;
      bottom: calc(50% - 5px);
      left: 0;
      content: '';
      width: 100%;
      height: 5px;
      background: $sub;
      transform: scale(0, 1);
      transform-origin: left top;
      transition: transform 0.5s;
    }

    &.active::after {
      transform: scale(1, 1);
    }
  }
}

.price-item-des {
  &-numtext2 {
    font-size: 50px;
    margin-right: -3px;
    position: relative;
    color: $sub;

    &-wrap {
      position: relative;

      opacity: 0;
      -webkit-transition: all 1s;
      -moz-transition: all 1s;
      -ms-transition: all 1s;
      -o-transition: all 1s;
      transition: all 1s;

      &.active {
        opacity: 1;
      }
    }

    &-tag {
      position: absolute;
      width: 100px;
      background: $sub;
      color: #fff;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      top: 0;
      left: -105px;
      font-size: 1.2rem;
      transform: rotate(-5deg);
    }
  }

  &-wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    height: 100%;

    &-one {
      .price-item-des {
        margin-top: 70px;
      }
    }
  }
}

.arrow-bottom {
  display: inline-block;
  width: 18px;
  height: 18px;
  margin: auto 10px 20px;
  border-bottom: 4px solid #000;
  border-right: 4px solid #000;
  transform: translateY(-100%) rotate(45deg);
  opacity: 0;
  -webkit-transition: all 1s;
  -moz-transition: all 1s;
  -ms-transition: all 1s;
  -o-transition: all 1s;
  transition: all 1s;

  &.active {
    transform: translateY(0) rotate(45deg);
    opacity: 1;
  }
}

.TopPageService {
}

.fade-right {
  transform: translateX(-100%);
  opacity: 0;
  -webkit-transition: all 1s;
  -moz-transition: all 1s;
  -ms-transition: all 1s;
  -o-transition: all 1s;
  transition: all 1s;

  &.active {
    transform: translateX(0);
    opacity: 1;
  }
}

.fade-left {
  transform: translateX(100%);
  opacity: 0;
  -webkit-transition: all 1s;
  -moz-transition: all 1s;
  -ms-transition: all 1s;
  -o-transition: all 1s;
  transition: all 1s;

  &.active {
    transform: translateX(0);
    opacity: 1;
  }
}

.fade-in {
  opacity: 0;
  -webkit-transition: all 1s;
  -moz-transition: all 1s;
  -ms-transition: all 1s;
  -o-transition: all 1s;
  transition: all 1s;

  &.active {
    opacity: 1;
  }
}

.recommend {
  &- {
    &wrap {
      margin-top: 160px;
      padding-left: 23%;
      padding-top: 160px;
      font-weight: 900;
      color: #fff;
    }

    &title {
      font-family: 'Shippori Mincho', serif;
      font-size: 2rem !important;
      color: #f2f2f2;
    }

    &text {
      font-size: 8rem;
      word-break: keep-all;
    }
  }
}

.member-wrap {
  display: flex;

  & li {
    max-width: 320px;

    img {
      transition: 1s all;
    }

    &:hover {
      img {
        transform: scale(1.2, 1.2);
        transition: 1s all;
      }

      & .icon-arrow-left {
        background-color: $sub;
      }
    }

    & .pic {
      height: 100%;
      overflow: hidden;
    }

    & .tmName {
      position: relative;
      display: block;
      font-size: 1.2rem;
      line-height: 2em;
      letter-spacing: 0.04em;
      background-color: #fff;
      text-align: center;
      color: #333;
      width: 85%;
      z-index: 99999;
      padding: 5% 0;
      margin: -20px auto 0;
    }

    & .icon-arrow-left {
      position: absolute;
      right: 15px;
      top: -15px;
      width: 30px;
      height: 30px;
      background-color: #000;
      -webkit-transition: all 1s;
      -moz-transition: all 1s;
      -ms-transition: all 1s;
      -o-transition: all 1s;
      transition: all 1s;

      &:after {
        content: '';
        display: inline-block;
        width: 15px;
        height: 15px;
        margin-left: -7.5px;
        margin-top: 7.5px;
        border-bottom: 2px solid #fff;
        border-right: 2px solid #fff;
        transform: rotate(-45deg);
      }
    }

    & .name {
      position: relative;
      display: block;
      font-size: 1.4rem;
      font-weight: 700;
    }

    & .home {
      position: relative;
      display: block;
    }

    & .kinds {
      display: block;
      margin-top: 5px;
      width: 100%;
    }
  }
}
.button {
  font-family: 'Shippori Mincho', serif;
  position: relative;
  display: flex;
  font-size: 2rem;
  line-height: 2em;
  letter-spacing: 0.04em;
  background-color: #ada554;
  text-align: center;
  color: #fff;
  max-width: 300px;
  width: 100%;
  z-index: 99999;
  height: 100%;
  margin: 0 auto;
  justify-content: center;
  align-items: center;
  -webkit-transition: all 1s;
  -moz-transition: all 1s;
  -ms-transition: all 1s;
  -o-transition: all 1s;
  transition: all 1s;

  a {
    color: #fff;
    font-size: 1.8rem;
    line-height: 2em;
    width: 100%;
  }

  &:hover {
    letter-spacing: 0.24em;
    & .icon-arrow-left {
      transform: translateX(3px);
    }
  }

  &-wrap {
    height: 70px;
    margin: 120px 0 80px;

    &.black {
      .button {
        background-color: $main;
        color: #fff;
      }

      .icon-arrow-left {
        background-color: #fff;

        &:hover {
          &:after {
            transform: translateX(-18px) rotate(-45deg);
          }
        }

        &:after {
          content: '';
          display: inline-block;
          width: 15px;
          height: 15px;
          margin-left: -7.5px;
          margin-top: 7.5px;
          border-bottom: 2px solid $main;
          border-right: 2px solid $main;
          transform: rotate(-45deg);
          -webkit-transition: all 1s;
          -moz-transition: all 1s;
          -ms-transition: all 1s;
          -o-transition: all 1s;
          transition: all 1s;
        }
      }
    }
  }

  & .icon-arrow-left {
    position: absolute;
    left: 15px;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    -webkit-transition: all 1s;
    -moz-transition: all 1s;
    -ms-transition: all 1s;
    -o-transition: all 1s;
    transition: all 1s;

    &:after {
      content: '';
      display: inline-block;
      width: 15px;
      height: 15px;
      margin-left: -7.5px;
      margin-top: 7.5px;
      border-bottom: 2px solid #fff;
      border-right: 2px solid #fff;
      transform: rotate(135deg);
    }
  }
}

@media screen and (max-width: 768px) {
  .top-inner {
    font-size: 5rem;
  }

  .news-bg {
    width: 40%;

    &2 {
      font-size: 3rem;
    }
  }
}

.icon-arrow-left {
  &-wrap {
    display: flex;
    justify-content: center;
    margin-top: 80px;
  }
  width: 50px;
  height: 50px;
  display: flex;
  /* align-items: center; */
  justify-content: center;
  -webkit-transition: all 1s;
  -moz-transition: all 1s;
  -ms-transition: all 1s;
  -o-transition: all 1s;
  transition: all 1s;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;

  &:hover {
    &:after {
      transform: translateX(-8px) rotate(135deg);
    }
  }

  &:after {
    content: '';
    display: inline-block;
    width: 15px;
    height: 15px;
    /* margin-left: 1.5px; */
    /* margin-top: 7.5px; */
    border-bottom: 2px solid #ada554;
    border-right: 2px solid #ada554;
    transform: rotate(135deg);
    -webkit-transition: all 1s;
    -moz-transition: all 1s;
    -ms-transition: all 1s;
    -o-transition: all 1s;
    transition: all 1s;
  }
}
</style>
